import { createTheme } from '@mui/material/styles';
import { pink, purple } from '@mui/material/colors';

const HEADER_FONT = "'Bebas Neue', Roboto, Arial, sans-serif";

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: pink,
        secondary: purple
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
        // Big headers use Bebas Neue (loaded in public/index.html). It only comes in
        // one weight and is condensed, so it is set regular and a little larger.
        h1: {
            fontFamily: HEADER_FONT,
            fontSize: '3.25rem',
            fontWeight: 400,
            letterSpacing: '0.02em',
            lineHeight: 1.1
        },
        h2: {
            fontFamily: HEADER_FONT,
            fontSize: '2.75rem',
            fontWeight: 400,
            letterSpacing: '0.02em',
            lineHeight: 1.1
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 800
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 800
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 800
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 800
        },


    },
    shape: {
        borderRadius: 3
    },



});

export { darkTheme, HEADER_FONT };